export default class ServiceConditionChoice {
  constructor(data) {
    this.id = data.id;
    this.name = data.name;
  }
}
